const audioContext = window.AudioContext || window.webkitAudioContext;
export default new audioContext();
